var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49993 3.00341C7.97266 3.00341 9.1666 4.19732 9.1666 5.67006C9.1666 7.14286 7.97266 8.33673 6.49993 8.33673C5.02715 8.33673 3.83324 7.14286 3.83324 5.67006C3.83324 4.19732 5.02715 3.00341 6.49993 3.00341ZM6.49993 4.00339C5.57946 4.00339 4.83325 4.74959 4.83325 5.67006C4.83325 6.59052 5.57946 7.33672 6.49993 7.33672C7.4204 7.33672 8.1666 6.59052 8.1666 5.67006C8.1666 4.74959 7.4204 4.00339 6.49993 4.00339ZM6.49993 0.666992C9.5756 0.666992 12.2307 2.767 12.9673 5.70993C13.0344 5.97779 12.8716 6.24933 12.6037 6.31639C12.3358 6.38339 12.0643 6.22066 11.9973 5.95273C11.3713 3.4523 9.11413 1.66699 6.49993 1.66699C3.88454 1.66699 1.62664 3.45383 1.00182 5.95579C0.934911 6.22366 0.663485 6.38659 0.395571 6.31973C0.127658 6.25279 -0.0352887 5.98139 0.031618 5.71346C0.767011 2.76881 3.4229 0.666992 6.49993 0.666992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.a66c01e252d66e1fff0432f3da6ce065.svg";
export { ForwardRef as ReactComponent };